(ns kyber.kyber-db.questionnaire)

(def model
  {:ident-key
   :questionnaire/uuid

   :refs
   {;; TODO This should use the assessment model
    :assessment/questions
    {:model :question-context
     :cardinality :many}

    :questionnaire/questions
    {:model :question-context
     :cardinality :many}}

   :schema
   #:questionnaire
   {:uuid
    {:doc "UUID of the questionnaire"}}})
